<div class="confirmation-wrapper">
  <mat-toolbar class="matpopup-header">
    <div>Resolve Property Conflict</div>
    <button type="button" class="close-btn" (click)="dialogRef.close();">
      <img src="../../../../../assets/icon/Cross.svg" alt="">
    </button>
  </mat-toolbar>
  <p class="mesg-text">
  <span class="warning"> ⚠️ Warning:</span>
    Any action taken here is permanent and cannot be undone.
    Please proceed carefully — once you remove or create, you won’t be able to revert it.
  </p>

  <div class="center">
    <button class="cnfrm-btn" (click)="resolvePropertyConflict(1)">
      Create New
    </button>
    <button class="cancel" (click)="resolvePropertyConflict(3)">
      Remove
    </button>
  </div>


</div>
